import {CitizensServicesCategory} from "../citizens-services-category/citizens-services-category.model";
import {CitizensServicesGroups} from "../citizens-services-groups/citizens-services-groups.model";
import {CitizensServicesResult} from "../citizens-services-result/citizens-services-result.model";
import {Ministry} from "../../system-settings/ministry/ministry.model";
import {Sector} from "../../system-settings/sector/sector.model";

export interface CitizensServices {
  id?: string;
  serviceUniqueId?: string;
  serviceIsSubService?: string;
  serviceName?: string;
  serviceDescription?: string;
  serviceHasSubService?: string;
  serviceGroups?: CitizensServicesGroups[];
  serviceCategory?: CitizensServicesCategory;
  serviceResults?: CitizensServicesResult;
  serviceForm?: {
    id?: string;
    hasForm?: boolean;
    formType?: 'FILLABLE' | 'UPLOADABLE' | 'NO_FORM'
  }
  serviceProvider?: {
    id?: string;
    institutionUniqueId?: string;
    institutionName?: string;
    institutionShortform?: string;
    institutionPhysicalAddress?: string;
    institutionEmail?: string;
    institutionPostcode?: string;
    institutionWebsite?: string;
    institutionPhones?: string;
    institutionMapUrl?: string;
    institutionMinistry?: Ministry;
    institutionSector?: Sector;
    institutionLogo: string;
  }
}

export enum ServiceGroupsTypeEnum {
  Government_to_Citizens = 'G2C',
  Government_to_Government = 'G2G',
  Government_to_Business = 'G2B',
  Government_to_Employee = 'G2E',
  Government_to_foreign = 'G2F'
}

export enum ProvisionMeansTypeEnum {
  Web_Applications = 'Web',
  Mobile_Applications = 'MobileApp',
  USSD = 'USSD',
  SMS = 'SMS'
}

export interface filteringInputCitizenServices {
  serviceUniqueId?: string,
  institutionUniqueId?: string,
  categoryUniqueId?: string,
  profileUniqueId?: string,
  approvedStatus?: string,
  consumerGroup?: ServiceGroupsTypeEnum[],
  districtUniqueId?: string,
  institutionType?: string,
  itemsPerPage?: number,
  pageNumber?: number,
  provissionMeans?: ProvisionMeansTypeEnum,
  regionUniqueId?: string,
  sectorUniqueId?: string,
  socialGroup?: SocialGroups[],
  streetUniqueId?: string,
  wardUniqueId?: string
  keyword?: string
}

export enum SocialGroups {
  Children = 'Children',
  Special_Needs = 'Special_Needs',
  Elderly = 'Elderly',
  Women = 'Women',
  Youth = 'Youth'
}


export interface filterByLocation {
  pageNumber: number
  regionalUniqueId?: string
  districtUniqueId?: string
  wardUniqueId?: string
  streetUniqueId?: string,
  itemsPerPage: number
}
